import TrackingService from '@/services/tracking';
import { theme } from '@/styles';
import MarkerIcon from '@/ui/Icons/MarkerIcon';
import { Icongraphy } from '@design-system/pc';
import { Coordinates } from '@remodeling/shop';
import React from 'react';
import { CustomOverlayMap, Map } from 'react-kakao-maps-sdk';
import styled, { css } from 'styled-components';

interface ShopMapProps {
  center: Coordinates;
  name: string;
  level: number;
  shopType: string;
  handleLevel: (num: number) => void;
}

const ShopMap = ({
  center,
  name,
  level,
  shopType,
  handleLevel,
}: ShopMapProps) => {
  return (
    <MapContainer>
      <Map
        center={{
          lat: center?.latitude,
          lng: center?.longitude,
        }}
        style={{
          width: '100%',
          height: '500px',
        }}
        zoomable={false}
        level={level}
      >
        <OverlayContainer
          style={{
            marginBottom: '40px',
          }}
        >
          <CustomOverlayMap
            position={{
              lat: center?.latitude,
              lng: center?.longitude,
            }}
          >
            <MarkerContainer>
              <MarkerIcon
                fill={theme.colors.accent_colors.blue.default}
                groupCode={shopType}
              />
              <StoreName>{name}</StoreName>
              <ArrowIcon></ArrowIcon>
            </MarkerContainer>
          </CustomOverlayMap>
        </OverlayContainer>
        <ButtonConatiner>
          <ButtonIconBox
            onClick={() => handleLevel(level - 1)}
            {...TrackingService.tagGTM('shop_info_view_map_zoom_plus_button')}
          >
            <Icongraphy variant="ic_plus_bold" size={32} />
          </ButtonIconBox>
          <Divider />
          <ButtonIconBox
            onClick={() => handleLevel(level + 1)}
            {...TrackingService.tagGTM('shop_info_view_map_zoom_minus_button')}
          >
            <Icongraphy variant="ic_minus_bold" size={32} />
          </ButtonIconBox>
        </ButtonConatiner>
      </Map>
    </MapContainer>
  );
};

export default ShopMap;

const MapContainer = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  position: relative;
`;

const OverlayContainer = styled.div``;

const MarkerContainer = styled.div`
  ${({ theme }) =>
    css`
      display: flex;
      padding: 3px 12px 3px 0px;
      border-radius: 100px;
      border: 1px solid ${theme.colors.accent_color.primary.default};
      height: 46px;
      z-index: 999;
      align-items: center;
      background-color: ${theme.colors.natural_color.white};
      svg {
        position: relative;
        left: -2px;
      }
    `}
`;

const ArrowIcon = styled.div`
  ${({ theme }) => css`
    height: 18px;
    width: 12px;
    position: absolute;
    bottom: -18px;
    left: 35px;
    border-bottom: 0px solid transparent;
    border-top: 8px solid ${theme.colors.accent_color.primary.default};
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
  `}
`;

const StoreName = styled.div`
  max-width: 208px;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${theme.colors.accent_colors.primary.default};
  ${theme.typography.button.lg_b};
`;

const ButtonConatiner = styled.div`
  ${({ theme }) => css`
    position: absolute;
    border: 1px solid ${theme.colors.natural_color.gray[200]};
    border-radius: 4px;
    bottom: 20px;
    right: 20px;
    z-index: 9;
    background-color: red;
  `}
`;

const ButtonIconBox = styled.div`
  ${({ theme }) => css`
    cursor: pointer;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.colors.natural_color.white};
    z-index: 999;
  `}
`;
const Divider = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 1px;
    background-color: ${theme.colors.natural_color.gray[200]};
  `};
`;
